export enum AdminModal {
  AddClientAdmin = 'AddClientAdmin',
  AddDemographic = 'AddDemographic',
  AddDepartment = 'AddDepartment',
  AddSSOProviderDomain = 'AddSSOProviderDomain',
  AddUser = 'AddUser',
  AutomatedEmail = 'AutomatedEmail',
  BenchmarkData = 'BenchmarkData',
  BrowsePreviousSurveys = 'BrowsePreviousSurveys',
  BrowseTemplateLibrary = 'BrowseTemplateLibrary',
  ChangeCompanyTimezone = 'ChangeCompanyTimezone',
  ChangeDepartmentParent = 'ChangeDepartmentParent',
  ChangeDepartmentPosition = 'ChangeDepartmentPosition',
  ChangeSurveyInviteTimeConfirmation = 'ChangeSurveyInviteTimeConfirmation',
  CloseLiveProjectConfirmation = 'CloseLiveProjectConfirmation',
  CloseProject = 'CloseProject',
  ConnectedDepartments = 'ConnectedDepartments',
  ContactList = 'ContactList',
  CopyOdDemandPoll = 'CopyOnDemandPoll',
  CreateClient = 'CreateClient',
  CreateProject = 'CreateProject',
  CreateProjectTemplate = 'CreateProjectTemplate',
  CustomCategory = 'CustomCategory',
  DashboardSettings = 'DashboardSettings',
  DeleteActFocusArea = 'DeleteActFocusArea',
  DeleteAccount = 'DeleteAccount',
  DeleteAnswerGroup = 'DeleteAnswerGroup',
  DeleteClientAdmin = 'DeleteClientAdmin',
  DeleteCustomCategory = 'DeleteCustomCategory',
  DeleteDemographic = 'DeleteDemographic',
  DeleteDepartment = 'DeleteDepartment',
  DeleteEmployee = 'DeleteEmployee',
  DeletePageConfirmation = 'DeletePageConfirmation',
  DeletePermissionGroup = 'DeletePermissionGroup',
  DeleteProject = 'DeleteProject',
  DeletePulseSurveyTemplate = 'DeletePulseSurveyTemplate',
  DeleteReminder = 'DeleteReminder',
  DeleteQuestionConfirmation = 'DeleteQuestionConfirmation',
  DeleteSSOProviderDomain = 'DeleteSSOProviderDomain',
  DeleteUser = 'DeleteUser',
  DeliveryStatistic = 'DeliveryStatistic',
  DemographyExternalEventApiEnabledModal = 'DemographyExternalEventApiEnabledModal',
  DepartmentExternalEventApiEnabledModal = 'DepartmentExternalEventApiEnabledModal',
  DistributeLifecycle = 'DistributeLifecycle',
  ProjectEmailTemplate = 'ProjectEmailTemplate',
  EmployeeForm = 'EmployeeForm',
  EmailScheduleModal = 'EmailScheduleModal',
  EmployeesDryUpload = 'EmployeesDryUpload',
  ImportPulseSurveyTemplate = 'ImportPulseSurveyTemplate',
  ImportSurvey = 'ImportSurvey',
  LifecycleAudienceUploadedConfirmation = 'AudienceUploadedConfirmation',
  LifecycleScheduleModal = 'LifecycleScheduleModal',
  OnboardInvitationScheduleModal = 'OnboardInvitationScheduleModal',
  MoveQuestion = 'MoveQuestion',
  NotificationsActivateAllUsersConfirmationModal = 'NotificationsActivateAllUsersConfirmationModal',
  NotificationsPauseAllUsersConfirmationModal = 'NotificationsPauseAllUsersConfirmationModal',
  PreviewDemographics = 'PreviewDemographics',
  PreviewDepartments = 'PreviewDepartments',
  PossibleLeavers = 'PossibleLeavers',
  PreviewQuestion = 'PreviewQuestion',
  PreviewSurvey = 'PreviewSurvey',
  PreviousSurvey = 'PreviousSurvey',
  PreviousTemplate = 'PreviousTemplate',
  PulseAiContextSaveConfirmationModal = 'PulseAiContextSaveConfirmationModal',
  CompanyProfileSaveConfirmationModal = 'CompanyProfileSaveConfirmationModal',
  PulseSurveyFrequency = 'PulseSurveyFrequency',
  RenamePulseSurvey = 'RenamePulseSurvey',
  Question = 'Question',
  QuestionLibrary = 'QuestionLibrary',
  QuestionMultiLanguage = 'QuestionMultiLanguage',
  ReUploadEmployees = 'ReUploadEmployees',
  RespondentExternalEventApiEnabledModal = 'RespondentExternalEventApiEnabledModal',
  PulseEmailTemplate = 'PulseEmailTemplate',
  ReopenProject = 'ReopenProject',
  ScheduleModal = 'ScheduleModal',
  SetSurveyDates = 'SetSurveyDates',
  SoftWarningEmployeeUpload = 'SoftWarningEmployeeUpload',
  SuccessfulEmployeesUpload = 'SuccessfulEmployeesUpload',
  TextOrMedia = 'TextOrMedia',
  TextOrMediaMultiLanguage = 'TextOrMediaMultiLanguage',
  UploadUsers = 'UploadUsers',
}
